import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Icon } from '../Icon/Icon.js';

var Component = props => {
  var classes = 'form-text invalid-feedback';
  var hcid = "errormessage-".concat("10.6.2");
  if (props.forceVisible) {
    classes += ' d-block';
  }
  return (
    /*#__PURE__*/
    /* eslint-disable react/no-children-prop */
    React.createElement("p", {
      id: "".concat(props.id, "-errormessage"),
      className: classes,
      tabIndex: -1,
      ref: props.forwardRef,
      "data-hcid": hcid
    }, /*#__PURE__*/React.createElement(Icon, {
      symbol: "messageAlert16",
      children: props.message,
      type: props.iconType,
      theme: props.IconTheme
    }))
  );
};
Component.displayName = 'ErrorMessage';
Component.defaultProps = {
  iconType: 'svgfile'
};
Component.propTypes = {
  forceVisible: PropTypes.bool,
  id: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
};
var ErrorMessage = /*#__PURE__*/React.forwardRef((props, ref) => {
  var attributes = _objectSpread2({}, props);
  if (ref) {
    attributes.forwardRef = ref;
  }
  return /*#__PURE__*/React.createElement(Component, attributes);
});
ErrorMessage.displayName = 'ErrorMessage';

export { ErrorMessage };
